import HoverIconButton from "components/HoverIconButton";
import React from "react";
import { COLORS } from "utils/styles";
import { DESKTOP_SCROLL_CONTAINER, scrollTopForId } from "utils/scroll";

const IconButtonBar = ({
  config,
  onClick,
  value,
  tooltipFormatter,
  tooltipPosition,
  customClasses
}) =>
  config.map((data, dataIx) => (
    <HoverIconButton
      key={dataIx}
      onClick={() => {
        onClick(data.value);
        scrollTopForId(DESKTOP_SCROLL_CONTAINER);
      }}
      hideIcon={Boolean(data.hideIcon)}
      type={data.icon}
      color={value === data.value && COLORS.blue}
      tooltipPosition={tooltipPosition}
      customClasses={customClasses}
      tooltip={
        tooltipFormatter
          ? tooltipFormatter(data.label || data.value)
          : `View as ${data.label || data.value}`
      }
    >
      {data.children || null}
    </HoverIconButton>
  ));

export default IconButtonBar;
